import React, { useMemo } from 'react';
import { SGSButton, SGSCard, SGSDeleteIcon, SGSEditIcon, SGSTable } from 'components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { rubriqueService } from 'core/services';
import { useQuery } from 'core/hooks';
import { Rubrique } from 'core/models';
import { Cell, ColumnInterface } from 'react-table';

type Props = {};

const FAQRubriqueList: React.FC<Props> = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { data, loading, refresh } = useQuery(rubriqueService.getRubriques, 'faq');

    const columns = useMemo<ColumnInterface<Rubrique>[]>(
        () => [
            {
                Header: t('rubrique.title'),
                accessor: 'name',
                //minWidth: 250,
                disableFilters: true,
                // headerClassName: styles.tableBorderRight__header,
                // className: `${styles.tableBorderRight__cell} justify-content-center text-center`,
            },
            {
                Header: '',
                accessor: 'none',
                className: 'p-0 align-items-stretch',
                minWidth: 45,
                maxWidth: 45,
                disableFilters: true,
                disableSortBy: true,
                Cell: ({ row }: Cell<Rubrique>) => {
                    return (
                        <div className="w-100 d-flex justify-content-end align-items-center">
                            <SGSEditIcon
                                className="mr-2"
                                onClick={() => {
                                    history.push(`/faq/rubriques/edit/${row.original.id}`);
                                }}
                            />
                            <SGSDeleteIcon onClick={() => rubriqueService.deleteRubrique(row.original.id).then(refresh)} />
                        </div>
                    );
                },
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t],
    );

    // TODO: à remplacer suivant ce qu'attends le back...
    // const [sortedData, setSortedData] = useState<Rubrique[]>([]);

    // useEffect(() => {
    //     if (!data) {
    //         return;
    //     }
    //     setSortedData(data);
    // }, [data]);

    // const onDrop: OnDropCallback = (result) => {
    //     if (result.addedIndex === result.removedIndex) {
    //         return;
    //     }

    //     // TODO: à voir selon ce qui est attendu par le back...
    //     const increment = result.addedIndex > result.removedIndex ? -1 : +1;

    //     const newData = Array.from(sortedData);

    //     newData[result.removedIndex].sortOrder = newData[result.addedIndex].sortOrder;

    //     for (let index = result.addedIndex; index !== result.removedIndex; index += increment) {
    //         if (index === result.removedIndex) {
    //             continue;
    //         }
    //         newData[index].sortOrder += increment;
    //     }

    //     setSortedData(newData);
    // };

    return (
        <div data-cy="rubriques-list">
            <div className="mb-4">
                <SGSButton
                    variant="outlined"
                    className="mr-2"
                    onClick={() => {
                        history.push('/faq');
                    }}
                >
                    {t('global.back')}
                </SGSButton>
                <SGSButton
                    onClick={() => {
                        history.push('/faq/rubriques/create');
                    }}
                    data-cy="create-rubrique"
                >
                    {t('rubrique.create')}
                </SGSButton>
            </div>
            <SGSCard color="default" className="w-100">
                <SGSTable loading={loading} columns={columns} data={data ?? []} />
            </SGSCard>
            {/* <PageLoader loading={loading}>
                <SGSCard>
                    <Container onDrop={onDrop} getChildPayload={(i) => data[i]} dragHandleSelector=".reorder-handle">
                        {sortedData.sort(bySortOrder).map((rubrique) => (
                            <Draggable key={rubrique.id}>
                                <div className="d-flex">
                                    <div>
                                        <SGSReorderIcon className="reorder-handle mr-4" />
                                    </div>
                                    <p className="mr-3 flex-grow-1">{rubrique.name}</p>
                                    <div>
                                        <SGSEditIcon
                                            className="mr-2"
                                            onClick={() => {
                                                history.push(`/faq/rubriques/edit/${rubrique.id}`);
                                            }}
                                        />
                                        <SGSDeleteIcon
                                            onClick={() => rubriqueService.deleteRubrique(rubrique.id).then(refresh)}
                                        />
                                    </div>
                                </div>
                            </Draggable>
                        ))}
                    </Container>
                </SGSCard>
            </PageLoader> */}
        </div>
    );
};

export default FAQRubriqueList;
